import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-wa-radio-group',
	templateUrl:'./WaRadioGroupPage.html',
	styles: [],
	styleUrls:['./WaRadioGroupPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaRadioGroupPage
{
	mdContent_432 = `\`\`\`java
import com.jwebmp.webawesome.components.radio.WaRadioGroup;
\`\`\``;
	mdContent_433 = `\`\`\`java
var group = new WaRadioGroup<>();
group.setLabel("Size");
group.add(new WaRadio<>("s", "Small"));
group.add(new WaRadio<>("m", "Medium"));
group.add(new WaRadio<>("l", "Large"));
\`\`\``;
}
